export enum GeoMatchStatusEnum {
  MATCH = 'MATCH',
  MISMATCH = 'MISMATCH',
  JOB_GEOLOCATION_NOT_FILLED = 'JOB_GEOLOCATION_NOT_FILLED',
}
